import { useEffect, useState } from 'react'

import { getInhabitantsStatistic } from '../../../../../api'

import { parseStatisticData } from './useStatisticData.utils'

export function useStatisticData() {
  const [allData, setAllData] = useState(null)

  useEffect(() => {
    getInhabitantsStatistic().then(({ data }) => {
      setAllData(data)
    })
  }, [])

  const { allCount, contactData, roleData, statusData, summaryData } =
    parseStatisticData(allData)

  return { allCount, contactData, roleData, statusData, summaryData }
}
